import Geosuggest from '@ubilabs/react-geosuggest';
import PropTypes from 'prop-types';
import {Component} from 'react';
import './address-picker.css';

class AddressPicker extends Component {
  calculateTimeZone = (callback) => (locationData) => {
    return locationData ? callback(locationData) : null;
  };

  render() {
    const {initialValue, onSelect, className, placeholder} = this.props;

    return (
      <div className={`${className} text-base`}>
        <Geosuggest
          autoActivateFirstSuggest={true}
          autoFocus={true}
          initialValue={initialValue}
          onKeyPress={() => this.onSelect}
          onSuggestSelect={this.calculateTimeZone(onSelect)}
          placeholder={placeholder}
          types={['address']}
        />
      </div>
    );
  }
}

AddressPicker.propTypes = {
  initialValue: PropTypes.string,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
};

AddressPicker.defaultProps = {
  onChange: () => {},
  onSelect: () => {},
};

export default AddressPicker;
